import { Router } from "@angular/router";
import { IndicesPasosPlataformasDigitales } from "../enumeraciones/indices-pasos-plataformas-digitales.enum";

export class PlataformasElectronicasDigitalesFlow {
  constructor(){}

  static conmutadorDePasosPlataformasDigitales(paso: number, router: Router) {
    switch(paso){
      case IndicesPasosPlataformasDigitales.CompletarInformacionPlataformas:
        router.navigate(['/solicitud/completa-informacion-plataformas']);
        break;
      case IndicesPasosPlataformasDigitales.Capacidades:
        router.navigate(['/solicitud/capacidad']);
        break;
      case IndicesPasosPlataformasDigitales.TipoDeEstablecimiento:
        router.navigate(['/solicitud/tipo-establecimiento']);
        break;
      case IndicesPasosPlataformasDigitales.CodigoDeConducta:
        router.navigate(['/solicitud/codigo-conducta']);
        break;
    }
  }
}
